import _color from "styles/constants/_colors.module.scss";

export const colorInfo = {
  purple: "#473079",
  lavender: "#EEEDEF",
  etcGrayLight: "#E4E4E4",
} as const;

export const COLORS = {
  primary: {
    black: "#000000",
    purple: "#473079",
    lavender: "#eeedef",
  },
  secondary: {
    red: "#ff0000",
    orange: "#fd5e02",
    yellow: "#ffa500",
    light: "#fbece4",
    light_2: "#FFD7C0",
  },
  gray: {
    medium: "#939393",
    light: "#cecece",
    light_2: "#f8f8f8",
    light_3: "#BDBDBD",
    white: "#ffffff",
  },
  etc: {
    green: "#2ABD27",
    green_light: "#E2FFE1",
    green_light_2: "#A5EEA4",
    orange: "#FF7020",
    orange_light: "#FFE6D8",
    orange_light_2: "#FFC5A5",
    red: "#BB2727",
    kakao_container: "#F3E926",
    kakao_label: "#191919",
    dawn: "#93b0d6",
    lemon_yellow: "#f5f49b",
  },
  card: {
    1: "#e3dbca",
    2: "#eae9e7",
    3: "#d4d0dc",
    4: "#e8dacd",
  },
} as const;

const color = _color as {
  transparent: string;

  "primary-black": string;
  "primary-purple": string;
  "primary-lavender": string;
  "primary-light": string;
  "primary-light-2": string;
  "primary-dark-2": string;

  "secondary-yellow": string;
  "secondary-orange": string;
  "secondary-red": string;
  "secondary-light": string;
  "secondary-light-2": string;

  "gray-medium": string;
  "gray-light": string;
  "gray-light-2": string;
  "gray-light-3": string;
  "gray-white": string;

  "etc-green": string;
  "etc-green-light": string;
  "etc-green-light-2": string;
  "etc-orange": string;
  "etc-orange-light": string;
  "etc-orange-light-2": string;
  "etc-red": string;
  "etc-kakao-container": string;
  "etc-kakao-label": string;
  "etc-dawn": string;
  "etc-lemon-yellow": string;
  "etc-gray-yellow": string;
  "etc-gray-light": string;
  "etc-pink-light": string;
  "etc-pink": string;
  "etc-purple-dark": string;
  "color-purple-1": string;

  "card-1": string;
  "card-2": string;
  "card-3": string;
  "card-4": string;
};

export type Color = keyof typeof color | "transparent";
